import { render, staticRenderFns } from "./ShippingSpend.vue?vue&type=template&id=60725c98&scoped=true"
import script from "./ShippingSpend.vue?vue&type=script&lang=js"
export * from "./ShippingSpend.vue?vue&type=script&lang=js"
import style0 from "./ShippingSpend.vue?vue&type=style&index=0&id=60725c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60725c98",
  null
  
)

export default component.exports